import { render, staticRenderFns } from "./selected-text-ai-assistant-form.vue?vue&type=template&id=097646e8"
import script from "./selected-text-ai-assistant-form.vue?vue&type=script&lang=js"
export * from "./selected-text-ai-assistant-form.vue?vue&type=script&lang=js"
import style0 from "./selected-text-ai-assistant-form.vue?vue&type=style&index=0&id=097646e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports